import zoomLevel from './zoomLevelModifiers.js'

const EARTH_RADIUS = 6371;

const findModifierRange = (angle, zoom, distance, multiplier) => {
    let zoom_level = `LEVEL_${zoom}`;

    let currentZoomObject = zoomLevel?.[zoom_level];
    if (!currentZoomObject) return false;

    let modifierKeys = Object.keys(currentZoomObject.angle).filter((range) => {
        let [from, to] = range.split('...')
        if (angle >= from && angle <= to) return range
        return false
    })

    let modifierKey = modifierKeys[0] ? modifierKeys[0] : false
    let minDistance = currentZoomObject?.minDistance
    let modifier = currentZoomObject?.angle?.[modifierKey];

    if (!modifier) return false;

    modifier = modifier * (multiplier * 0.75) ;

    if (minDistance && (minDistance * 2 * multiplier > distance)) {
        // minDistance = minDistance * multiplier;
        return modifier * (distance / (minDistance * 2.5 * multiplier))
    }
    return modifier
}

function degreesToRadians(degrees) {
    let pi = Math.PI;
    return degrees * (pi / 180);
}

function radiansToDegrees(radians) {
    let pi = Math.PI;
    return radians * (180 / pi);
}

function angleFromCoordinate([lat1, long1], [lat2, long2]) {

    let dLon = long2 - long1;

    let y = Math.sin(dLon) * Math.cos(lat2);
    let x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

    let brng = Math.atan2(y, x);

    brng = radiansToDegrees(brng)

    brng = (brng + 360) % 360;
    brng = 360 - brng;

    return brng;
}

function angleRevert(angle) {
    if (angle > 180) {
        return Math.abs(angle - 180);
    } else {
        return 360 - Math.abs(angle - 180);
    }
    // return Math.abs(angle - 180);
}


function computeOffset([lat, long], distance, heading) {
    if (!distance) return [lat, long];

    let testDistance = distance / EARTH_RADIUS;
    let testHeading = degreesToRadians(heading);

    let fromLat = degreesToRadians(lat);
    let fromLng = degreesToRadians(long);

    let cosDistance = Math.cos(testDistance);
    let sinDistance = Math.sin(testDistance);
    let sinFromLat = Math.sin(fromLat);
    let cosFromLat = Math.cos(fromLat);
    let sinLat = cosDistance * sinFromLat + sinDistance * cosFromLat * Math.cos(testHeading);
    let dLng = Math.atan2(
        sinDistance * cosFromLat * Math.sin(testHeading),
        cosDistance - sinFromLat * sinLat);

    return [radiansToDegrees(Math.asin(sinLat)), radiansToDegrees(fromLng + dLng)];
}

function applyModifier([lat, long], modifier) {
    if (!modifier) {
        return [lat, long]
    }


    const [latModifier, longModifier] = modifier

    return [lat - (lat * latModifier), long - (long * longModifier)]
}


function modifyLinePoint([lat, long], angle, zoom, distance = 0, multiplier = 1) {
    if (lat > 75 || lat < -65) return [lat, long]

    let localAngle = angle;

    let modifier = findModifierRange(localAngle, zoom, distance, multiplier);
    let modifiedPoint = computeOffset([lat, long], modifier, localAngle)

    return modifiedPoint
}

function distance(point1, point2, humanReadable = true) {
    let [lat1, lon1] = point1;
    let [lat2, lon2] = point2;
    let R = 6371; // km (change this constant to get miles)
    let dLat = (lat2 - lat1) * Math.PI / 180;
    let dLon = (lon2 - lon1) * Math.PI / 180;
    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;
    if (!humanReadable) {
        return d
    } else {
        if (d > 1) return Math.round(d) + " km";
        else if (d <= 1) return Math.round(d * 1000) + " m";
        return d;
    }
}

function pointsAngle([lat1, long1], [lat2, long2]) {
    let brng;
    brng = (Math.atan2(long2 - long1, lat2 - lat1) * 180 / Math.PI);
    brng = (brng + 360) % 360;
    return brng
}

function modifyLinePoints(point1, point2, zoom, multiplier) {
    // let point1,point2;
    let d = distance(point1, point2, false);

    let pointsAngle1 = pointsAngle(point1, point2);
    let pointsAngle2 = pointsAngle(point2, point1);

    let modifiedPoint1 = modifyLinePoint(point1, pointsAngle1, zoom, d, multiplier);
    let modifiedPoint2 = modifyLinePoint(point2, pointsAngle2, zoom, d, multiplier);

    return [modifiedPoint1, modifiedPoint2]
}

export {angleFromCoordinate, angleRevert, modifyLinePoint, modifyLinePoints, distance}